import * as React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardTitle } from "@/components/ui/card";
import { X, Pencil, Trash2 } from "lucide-react";
import { useGetHRQuery, useDeleteHRMutation } from "@/store/hrAuth";
import HRForm from "./RegisterStaff";

const HRList = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [editingHR, setEditingHR] = React.useState(null);

  const { data: hrList = [], isLoading } = useGetHRQuery();
  const [deleteHR] = useDeleteHRMutation();

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this HR personnel?")) {
      try {
        await deleteHR(id).unwrap();
      } catch (error) {
        console.error("Failed to delete HR:", error);
      }
    }
  };

  const handleEdit = (hr) => {
    setEditingHR(hr);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditingHR(null);
  };

  return (
    <div className="relative min-h-screen p-6 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold">HR Management</h1>
          <Button onClick={() => setIsModalOpen(true)}>Add New HR</Button>
        </div>

        {isLoading ? (
          <div className="text-center py-8">Loading...</div>
        ) : (
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {hrList?.length > 0 &&
              hrList.map((hr) => (
                <Card key={hr._id} className="relative">
                  <CardTitle className="text-xl ml-6 mt-2">
                    <span>{hr.name}</span>
                  </CardTitle>
                  <CardContent>
                    <p className="text-gray-600 mb-4">{hr.email}</p>
                    <div className="flex gap-2">
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handleDelete(hr._id)}
                        className="text-red-600 hover:bg-red-50"
                      >
                        <Trash2 className="w-4 h-4 mr-1" />
                        Delete
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handleEdit(hr)}
                      >
                        <Pencil className="w-4 h-4 mr-1" />
                        Edit
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              ))}
          </div>
        )}

        {/* Modal for Register/Edit HR */}
        {isModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="relative bg-white rounded-lg w-full max-w-md p-4">
              <Button
                variant="ghost"
                size="icon"
                className="absolute right-2 top-2"
                onClick={handleCloseModal}
              >
                <X className="w-4 h-4" />
              </Button>
              <HRForm
                hrData={editingHR}
                onClose={handleCloseModal}
                mode={editingHR ? "edit" : "create"}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HRList;
